// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"b8eb1fb1","124":"f539079a","212":"385560e0","538":"f33f33fd","703":"07be8216","940":"b9a4d512"}[chunkId] + ".chunk.js";
};